export default "__VITE_ASSET__B$LY2tNu__"